import { apiTypeHelper } from "@/base/network"

export const LOGIN = apiTypeHelper('LOGIN')
export const LOGOUT = apiTypeHelper('LOGOUT')
export const REFRESH_TOKEN = apiTypeHelper('REFRESH_TOKEN')
export const RESET_PASSWORD = apiTypeHelper('RESET_PASSWORD')